export default function CrawlerPolicy() {
  return (
    <section data-testid="crawler-section" className="space-y-6">
      <h1 className="hs-display text-3xl md:text-4xl">Crawler policy</h1>
      <ul className="list-disc space-y-2 pl-6 text-muted">
        <li>User-Agent identifies as <code className="hs-mono">HerdSafe-Observatory</code>, with a link back to this page.</li>
        <li>Honours <code className="hs-mono">robots.txt</code> and crawl-delay.</li>
        <li>Per-host rate limit via <code className="hs-mono">CRAWL_RATE_PER_HOST</code>.</li>
        <li>Payload cap via <code className="hs-mono">CRAWL_MAX_BYTES</code> (default 2&nbsp;MiB).</li>
        <li>Text only — tarballs, wheels, and executables are never downloaded nor executed.</li>
      </ul>
    </section>
  );
}
